/* eslint-disable */

import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import { useAuth0, withAuthenticationRequired } from '@auth0/auth0-react';
import { useAppSelector } from '../../redux/hooks';
import { selectUserInfo } from '../../components/SecureRoute/slice';
import PageContainer from '../../components/PageContainer/PageContainer';
import { Container, ContentHeader, Title, ContentBody, ProfileGrid, ProfileCard, CardLabel, CardValue } from './UserProfile.styled';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';

const UserProfile: React.FC = () => {
  const user = useAppSelector(selectUserInfo);
  const [open, setOpen] = useState(false);

  return (
    <PageContainer title='My Profile' open={open} setOpen={setOpen}>
      <Container>
        <ContentHeader>
          <Title>My Profile</Title>
        </ContentHeader>

        <ContentBody>
          {/* Avatar and Email Section */}
          <ProfileCard>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, padding: 2 }}>
              {user?.picture && (
                <Avatar
                  src={user.picture}
                  sx={{ width: 100, height: 100 }}
                  alt={user.name}
                />
              )}
              <div>
                <div style={{ fontSize: '18px', fontWeight: 600, color: '#0a1e3d' }}>
                  {user?.name}
                </div>
                <div style={{ fontSize: '14px', color: '#666', marginTop: '4px' }}>
                  {user?.email}
                  {user?.email_verified && (
                    <span style={{ marginLeft: '8px', color: '#4caf50', fontWeight: 600 }}>
                      ✓ Verified
                    </span>
                  )}
                </div>
              </div>
            </Box>
          </ProfileCard>

          {/* Personal Information */}
          <ProfileCard>
            <div style={{ padding: '16px', borderBottom: '1px solid #e0e0e0', fontWeight: 600, color: '#0a1e3d' }}>
              Personal Information
            </div>
            <ProfileGrid>
              <div>
                <CardLabel>First Name</CardLabel>
                <CardValue>{user?.given_name || '-'}</CardValue>
              </div>
              <div>
                <CardLabel>Last Name</CardLabel>
                <CardValue>{user?.family_name || '-'}</CardValue>
              </div>
              <div>
                <CardLabel>Nickname</CardLabel>
                <CardValue>{user?.nickname || '-'}</CardValue>
              </div>
              <div>
                <CardLabel>Gender</CardLabel>
                <CardValue>{user?.gender || '-'}</CardValue>
              </div>
              <div>
                <CardLabel>Date of Birth</CardLabel>
                <CardValue>{user?.birthdate || '-'}</CardValue>
              </div>
              <div>
                <CardLabel>Locale</CardLabel>
                <CardValue>{user?.locale || '-'}</CardValue>
              </div>
            </ProfileGrid>
          </ProfileCard>

          {/* Contact Information */}
          <ProfileCard>
            <div style={{ padding: '16px', borderBottom: '1px solid #e0e0e0', fontWeight: 600, color: '#0a1e3d' }}>
              Contact Information
            </div>
            <ProfileGrid>
              <div style={{ gridColumn: '1 / -1' }}>
                <CardLabel>Email</CardLabel>
                <CardValue>{user?.email}</CardValue>
                {user?.email_verified && (
                  <div style={{ fontSize: '12px', color: '#4caf50', marginTop: '4px', fontWeight: 600 }}>
                    ✓ Verified
                  </div>
                )}
              </div>
              <div style={{ gridColumn: '1 / -1' }}>
                <CardLabel>Phone Number</CardLabel>
                <CardValue>{user?.phone_number || '-'}</CardValue>
                {user?.phone_number_verified && (
                  <div style={{ fontSize: '12px', color: '#4caf50', marginTop: '4px', fontWeight: 600 }}>
                    ✓ Verified
                  </div>
                )}
              </div>
            </ProfileGrid>
          </ProfileCard>

          {/* Online Presence */}
          <ProfileCard>
            <div style={{ padding: '16px', borderBottom: '1px solid #e0e0e0', fontWeight: 600, color: '#0a1e3d' }}>
              Online Presence
            </div>
            <ProfileGrid>
              <div style={{ gridColumn: '1 / -1' }}>
                <CardLabel>Profile URL</CardLabel>
                <CardValue>{user?.profile ? <a href={user.profile} target="_blank" rel="noreferrer">{user.profile}</a> : '-'}</CardValue>
              </div>
              <div style={{ gridColumn: '1 / -1' }}>
                <CardLabel>Website</CardLabel>
                <CardValue>{user?.website ? <a href={user.website} target="_blank" rel="noreferrer">{user.website}</a> : '-'}</CardValue>
              </div>
            </ProfileGrid>
          </ProfileCard>

          {/* Account Information */}
          <ProfileCard>
            <div style={{ padding: '16px', borderBottom: '1px solid #e0e0e0', fontWeight: 600, color: '#0a1e3d' }}>
              Account Information
            </div>
            <Box sx={{ padding: 2 }}>
              <div style={{ marginBottom: '16px' }}>
                <CardLabel>User ID (sub)</CardLabel>
                <CardValue style={{ wordBreak: 'break-all', fontSize: '12px' }}>{user?.sub}</CardValue>
              </div>
              <div>
                <CardLabel>Last Updated</CardLabel>
                <CardValue>
                  {user?.updated_at ? new Date(user.updated_at).toLocaleString() : '-'}
                </CardValue>
              </div>
            </Box>
          </ProfileCard>
        </ContentBody>
      </Container>
    </PageContainer>
  )
}

export default withAuthenticationRequired(UserProfile)
